import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { environment as env } from '@env/environment';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, PasswordLoginOtpChallenge } from "@app/core/services/AuthenticationService"
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '@app/core/services/UserService';
import { FileService } from '@app/core/services/FileService';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';

@Component({
  standalone: false,
  selector: 'anms-emailpass',
  templateUrl: './emailpass.component.html',
  styleUrls: ['./emailpass.component.css']
})
export class EmailpassComponent implements OnInit, OnDestroy {
  logo = env.logoUrl || 'assets/logo.png';
  public user: CreateUser = this.getUser();
  public createAccountMethod: number = 1; // 0, default, 1 = BankId, 2 = Manual
    routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
    versions = env.versions;
    public errorMsg = '';
    loading = false;
    returnUrl: string;
    public appId: number = env.appId;

    message: string = 'Felaktigt lösenord!';
    actionButtonLabel: string = 'Retry';
    action: boolean = false;
    setAutoHide: boolean = true;
    autoHide: number = 10000;
    tosAccepted: any;
  errorMessage: any = "";
  createAccountError = "";
  bankIdUrl = "";
  otpChallenge: PasswordLoginOtpChallenge | null = null;
  otpCode = '';
  otpExpiresInSeconds = 0;
  otpResendInSeconds = 0;
  private otpExpiresAtMs = 0;
  private otpResendAvailableAtMs = 0;
  private otpTimer: ReturnType<typeof setInterval> | null = null;
  private readonly loginMethodKey = 'loginMethod';
  private readonly loginEmailKey = 'loginEmail';
  private readonly loginAuthenticatedKey = 'loginAuthenticated';

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        public snackBar: MatSnackBar,
        private userService: UserService,
        public fileService: FileService,
        private localStorageService: LocalStorageService,
        private ngZone: NgZone,
        private changeDetectorRef: ChangeDetectorRef,
      
    ) { }

  ngOnInit() {
    this.bankIdUrl = env.bankIdUrl;
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.user = this.getUser();
    }

  ngOnDestroy() {
    this.clearOtpTimer();
  }

  onSubmit() {
      
        this.createAccount();       
  }

  redirectToURL(url) {
    window.location.href = url;
  }

  validateForm() {

    if (this.appId == 1) {

      if (this.user.firstname == "") {
        this.errorMessage = "Förnamn saknas";
        return false;
      }
       

      if (this.user.lastname == "") {
        this.errorMessage = "Efternamn saknas";
        return false;
      }
    }

    if (this.appId == 2) {
      if (this.user.companyname == "") {
        this.errorMessage = "Företagsnamn saknas";
        return false;
      }
    }

    if (this.user.email == "") {
      this.errorMessage = "Email saknas";
      return false;
    }

    if (this.user.phone == "") {
      this.errorMessage = "Telefon saknas";
      return false;
    }

    else {
      this.errorMessage = "";
      return true;
    }

  }

  createAccount() {
        this.createAccountError = "";
        this.loading = true;
        this.authenticationService.createAccount(this.user)
            .subscribe(
                data => {
                  
                    // No error
                    if (JSON.stringify(data) != '"error"') {

                        // Auto login
                        this.authenticationService.login(this.user.email, null, null, null, null, null, this.appId)
                            .subscribe(
                                data => {
                                  if (data?.RequiresOtp) {
                                    this.localStorageService.setItem(this.loginMethodKey, 'email');
                                    this.localStorageService.setItem(this.loginEmailKey, this.user.email);
                                    this.otpChallenge = data;
                                    this.otpCode = '';
                                    this.setOtpDeadlines(data);
                                    this.startOtpTimer();
                                    this.loading = false;
                                    return;
                                  }

                                  if (data?.Jwt) {
                                    this.localStorageService.setItem(this.loginAuthenticatedKey, true);
                                    this.localStorageService.setItem(this.loginMethodKey, 'email');
                                    this.localStorageService.setItem(this.loginEmailKey, this.user.email);
                                    this.userService.setHttpOptions();
                                    this.router.navigateByUrl("/settings");
                                  }
                                },
                                error => {

                                }
                            );

                    }

                    this.loading = false;
                },
              error => {
                    this.createAccountError = error.status === 409
                      ? "Det finns redan ett konto med den e-postadressen. Försök att logga in i stället."
                      : "Kontot kunde inte skapas. Försök igen eller kontakta support om problemet kvarstår.";
                    this.loading = false;
                });
    }


    getUser() {
        return new CreateUser("", "", "", "", "", "", "");
    }

    openLink(link: string) {
        window.open(link, '_blank');
    }

  verifyOtp() {
    if (!this.otpChallenge || !this.canVerifyOtp()) {
      return;
    }

    this.loading = true;
    this.authenticationService.verifyLoginOtp(this.otpChallenge.ChallengeId, this.otpCode)
      .subscribe(
        data => {
          this.loading = false;

          if (data?.Jwt) {
            this.localStorageService.setItem(this.loginAuthenticatedKey, true);
            this.localStorageService.setItem(this.loginMethodKey, 'email');
            this.localStorageService.setItem(this.loginEmailKey, this.user.email);
            this.clearOtpState();
            this.userService.setHttpOptions();
            this.router.navigateByUrl('/settings');
          }
        },
        () => {
          this.loading = false;
        });
  }

  resendOtp() {
    if (!this.otpChallenge || this.otpResendInSeconds > 0) {
      return;
    }

    this.loading = true;
    this.authenticationService.login(this.user.email, null, null, null, null, null, this.appId)
      .subscribe(
        data => {
          this.loading = false;

          if (data?.RequiresOtp) {
            this.otpChallenge = data;
            this.otpCode = '';
            this.setOtpDeadlines(data);
            this.startOtpTimer();
          }
        },
        () => {
          this.loading = false;
        });
  }

  onOtpCodeChange(value: string) {
    this.otpCode = (value || '').replace(/\D/g, '').slice(0, 6);
  }

  onOtpPaste(event: ClipboardEvent) {
    const pastedCode = event.clipboardData?.getData('text') || '';
    const normalizedCode = pastedCode.replace(/\D/g, '').slice(0, 6);
    if (normalizedCode.length !== 6) {
      return;
    }

    event.preventDefault();
    this.otpCode = normalizedCode;

    if (!this.loading) {
      this.verifyOtp();
    }
  }

  focusOtpInput(input: HTMLInputElement) {
    input.focus();
  }

  getOtpSlotValue(index: number) {
    return this.otpCode?.[index] || '';
  }

  isOtpSlotActive(index: number, input: HTMLInputElement) {
    const activeIndex = Math.min((this.otpCode || '').length, 5);
    return document.activeElement === input && index === activeIndex;
  }

  canVerifyOtp() {
    return /^\d{6}$/.test((this.otpCode || '').trim());
  }

  formatCountdown(totalSeconds: number) {
    const safeSeconds = Math.max(0, totalSeconds);
    const minutes = Math.floor(safeSeconds / 60).toString().padStart(2, '0');
    const seconds = (safeSeconds % 60).toString().padStart(2, '0');

    return `${minutes}:${seconds}`;
  }

  private startOtpTimer() {
    this.clearOtpTimer();
    this.updateOtpCountdowns();
    this.otpTimer = setInterval(() => {
      this.ngZone.run(() => this.updateOtpCountdowns());
    }, 1000);
  }

  private updateOtpCountdowns() {
    if (!this.otpChallenge) {
      this.clearOtpTimer();
      return;
    }

    const now = Date.now();
    this.otpExpiresInSeconds = Math.max(0, Math.ceil((this.otpExpiresAtMs - now) / 1000));
    this.otpResendInSeconds = Math.max(0, Math.ceil((this.otpResendAvailableAtMs - now) / 1000));
    this.changeDetectorRef.detectChanges();

    if (this.otpExpiresInSeconds <= 0 && this.otpResendInSeconds <= 0) {
      this.clearOtpTimer();
    }
  }

  private setOtpDeadlines(challenge: PasswordLoginOtpChallenge) {
    const now = Date.now();
    const parsedExpiresAtMs = Date.parse(challenge?.ExpiresAtUtc);
    const parsedResendAtMs = Date.parse(challenge?.ResendAvailableAtUtc);

    this.otpExpiresAtMs = Number.isFinite(parsedExpiresAtMs)
      ? parsedExpiresAtMs
      : now + (10 * 60 * 1000);
    this.otpResendAvailableAtMs = Number.isFinite(parsedResendAtMs)
      ? parsedResendAtMs
      : now + (60 * 1000);
  }

  private clearOtpState() {
    this.otpChallenge = null;
    this.otpCode = '';
    this.otpExpiresInSeconds = 0;
    this.otpResendInSeconds = 0;
    this.otpExpiresAtMs = 0;
    this.otpResendAvailableAtMs = 0;
    this.clearOtpTimer();
  }

  private clearOtpTimer() {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    }
  }
}


export class CreateUser {
    constructor
        (
            public username: string,
            public firstname: string,
            public lastname: string,
            public companyname: string,
            public email: string,
            public phone: string,
            public DiscountCode: string
        ) { }
}



